import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo.svg'


const _hoisted_1 = { class: "admin-site-header" }
const _hoisted_2 = { class: "full-container" }
const _hoisted_3 = { class: "custom-row" }
const _hoisted_4 = { class: "logo" }
const _hoisted_5 = { class: "header-right" }
const _hoisted_6 = { class: "login-user-info" }
const _hoisted_7 = {
  href: "javascript:void(0)",
  id: "userHdrInfoLink"
}
const _hoisted_8 = { class: "small-user-img" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  class: "login-user-info-dropdown",
  id: "userHdrDropdown"
}
const _hoisted_11 = { class: "login-user-info-dropdown-in" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("button", {
          id: "leftMenuSlideTop",
          class: "mobile-nav-icon"
        }, [
          _createElementVNode("span")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, { to: "/authority/dashboard" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Logo"
              }, null, -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("a", _hoisted_7, [
              _createElementVNode("i", _hoisted_8, [
                _createElementVNode("img", {
                  src: _ctx.imageUrl,
                  alt: "User Avatar"
                }, null, 8, _hoisted_9)
              ]),
              _createElementVNode("span", null, _toDisplayString(_ctx.firstname), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_router_link, {
                  class: _normalizeClass(["my-profile-icon", { active: _ctx.$route.path === '/authority/profile' }]),
                  id: "userHdrPfileLink",
                  to: "/authority/profile"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.constants['MY_PROFILE_MENU']), 1)
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_router_link, {
                  class: _normalizeClass(["edit-profile-icon", { active: _ctx.$route.path === '/authority/edit-profile' }]),
                  id: "userHdrEditPfileLink",
                  to: "/authority/edit-profile"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.constants['EDIT_PROFILE_MENU']), 1)
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_router_link, {
                  class: _normalizeClass(["change-password-icon", { active: _ctx.$route.path === '/authority/change-password' }]),
                  id: "userHdrChPwtLink",
                  to: "/authority/change-password"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.constants['CHANGE_PASSWORD_MENU']), 1)
                  ]),
                  _: 1
                }, 8, ["class"])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}